import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Edit from './edit';
import Store from './store';
import List from './list';

function Router() {
	return (
		<Routes>
			<Route path="/" element={<List />} />
			<Route path="/:userId" element={<Edit />} />
			<Route path="/new" element={<Store />} />
		</Routes>
	);
}

export default Router;